import { useApp } from "../context";
import { Shell } from "../components";

const GAME_MODES = [
  {
    id: "solo",
    icon: "🧠",
    title: "Solo Play",
    desc: "Test your knowledge alone. Earn GT tokens for every correct answer!",
    color: "#6c5ce7",
    tag: "Earn GT",
    tagColor: "#6c5ce7",
    available: true,
  },
  {
    id: "duo",
    icon: "⚔️",
    title: "Duo Play",
    desc: "Challenge any member to a 1v1 Trivia battle. Bet GT tokens. Winner takes all!",
    color: "#e91e8c",
    tag: "Bet & Win",
    tagColor: "#e91e8c",
    available: true,
  },
  {
    id: "couple",
    icon: "💑",
    title: "Couple Play",
    desc: "Playful & spicy games for two. Perfect for long-distance or bedroom fun!",
    color: "#ef4444",
    tag: "Coming Soon",
    tagColor: "#888",
    available: false,
  },
  {
    id: "multi",
    icon: "🎲",
    title: "Multi Play",
    desc: "Free for all! Trivia, Spin the Bottle, and card games with 3+ players.",
    color: "#f59e0b",
    tag: "Coming Soon",
    tagColor: "#888",
    available: false,
  },
  {
    id: "group",
    icon: "🎉",
    title: "Group Event Play",
    desc: "Physical meetup party games. Everyone joins on their own phone. Host sets the rules!",
    color: "#10b981",
    tag: "Coming Soon",
    tagColor: "#888",
    available: false,
  },
];

export default function GamesPage() {
  const { dark, go, flash } = useApp();

  const bg = dark ? "#080810" : "#f4f5f9";
  const card = dark ? "#0f0f1a" : "#ffffff";
  const border = dark ? "#ffffff12" : "#e0e2eb";
  const text = dark ? "#ffffff" : "#1a1c2e";
  const sub = dark ? "#ffffff60" : "#6b7094";
  const faint = dark ? "#ffffff30" : "#9ca0b8";

  const handlePlay = (mode) => {
    if (mode.id === "duo") { go("duo_play"); return; }
    if (mode.id === "solo") { go("solo_play"); return; }
    flash(`${mode.title} coming soon! 🚀`);
  };

  return (
    <div style={{ minHeight: "100vh", background: bg, fontFamily: "'DM Sans',sans-serif" }}>
      <Shell title="Games 🎮">

        {/* Hero */}
        <div style={{ background: "linear-gradient(135deg,#0d0020,#1a0030,#0a0015)", borderRadius: 20, padding: "20px 16px", marginBottom: 20, border: "1px solid #6c5ce720", position: "relative", overflow: "hidden" }}>
          <div style={{ position: "absolute", top: -40, right: -40, width: 160, height: 160, borderRadius: "50%", background: "#6c5ce708" }} />
          <div style={{ position: "absolute", bottom: -30, left: -20, width: 120, height: 120, borderRadius: "50%", background: "#e91e8c08" }} />
          <div style={{ fontSize: 36, marginBottom: 8 }}>🎮</div>
          <div style={{ fontSize: 22, fontWeight: 900, color: "#fff", marginBottom: 6 }}>
            Play. Bet. <span style={{ color: "#e91e8c" }}>Win.</span>
          </div>
          <div style={{ fontSize: 13, color: "#ffffff60", lineHeight: 1.6 }}>
            Compete with members, earn GT tokens and have the most fun you've had in a long time 😏
          </div>
        </div>

        {/* Game Mode Cards */}
        <div style={{ fontSize: 11, fontWeight: 700, color: faint, marginBottom: 12, textTransform: "uppercase", letterSpacing: 1 }}>Choose Your Mode</div>

        {GAME_MODES.map((mode) => (
          <div key={mode.id} style={{ background: card, borderRadius: 18, border: `1px solid ${mode.available ? mode.color + "30" : border}`, padding: "18px 16px", marginBottom: 12, position: "relative", overflow: "hidden", opacity: mode.available ? 1 : 0.75 }}>
            {/* Color accent line */}
            <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 3, background: `linear-gradient(90deg,${mode.color},${mode.color}00)` }} />

            <div style={{ display: "flex", gap: 14, alignItems: "flex-start" }}>
              {/* Icon */}
              <div style={{ width: 56, height: 56, borderRadius: 16, background: mode.color + "20", border: `1px solid ${mode.color}30`, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 26, flexShrink: 0 }}>
                {mode.icon}
              </div>

              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 4 }}>
                  <div style={{ fontSize: 15, fontWeight: 800, color: text }}>{mode.title}</div>
                  <span style={{ fontSize: 9, fontWeight: 700, color: mode.available ? mode.tagColor : "#888", background: mode.available ? mode.tagColor + "20" : "#88888820", padding: "2px 8px", borderRadius: 20, border: `1px solid ${mode.available ? mode.tagColor + "40" : "#88888840"}` }}>
                    {mode.tag}
                  </span>
                </div>
                <div style={{ fontSize: 12, color: sub, lineHeight: 1.5, marginBottom: 12 }}>{mode.desc}</div>

                <button
                  onClick={() => handlePlay(mode)}
                  style={{
                    padding: "10px 20px",
                    borderRadius: 12,
                    border: mode.available ? "none" : `1px solid ${border}`,
                    background: mode.available ? `linear-gradient(135deg,${mode.color},${mode.color}cc)` : "transparent",
                    color: mode.available ? "#fff" : faint,
                    fontSize: 12,
                    fontWeight: 700,
                    cursor: mode.available ? "pointer" : "default",
                    fontFamily: "inherit",
                  }}
                >
                  {mode.available ? "Play Now →" : "Coming Soon"}
                </button>
              </div>
            </div>
          </div>
        ))}

        {/* GT info */}
        <div style={{ background: dark ? "#1a1a0a" : "#fffbeb", border: "1px solid #f59e0b30", borderRadius: 14, padding: "14px 16px", marginTop: 8, marginBottom: 20 }}>
          <div style={{ fontSize: 13, fontWeight: 700, color: "#f59e0b", marginBottom: 4 }}>🪙 About GT Tokens in Games</div>
          <div style={{ fontSize: 12, color: sub, lineHeight: 1.6 }}>
            You can play for fun or bet GT tokens. When you bet, your tokens are frozen until the game ends — winner takes both bets. Draws refund both players. Get GT tokens from your wallet.
          </div>
        </div>

        <div style={{ height: 80 }} />
      </Shell>
    </div>
  );
}